import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SEO_BY_ROUTE, absoluteCanonical } from '../lib/seo';

function setMeta(selector, attribute, value) {
  const node = document.querySelector(selector);
  if (node) node.setAttribute(attribute, value);
}

export default function RouteSEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalized = pathname !== '/' ? pathname.replace(/\/$/, '') : '/';
    const meta = SEO_BY_ROUTE[normalized];
    if (!meta) return;

    const canonical = absoluteCanonical(meta.canonicalPath);
    document.title = meta.title;
    setMeta('meta[name="description"]', 'content', meta.description);
    setMeta('meta[property="og:title"]', 'content', meta.title);
    setMeta('meta[property="og:description"]', 'content', meta.description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('link[rel="canonical"]', 'href', canonical);
  }, [pathname]);

  return null;
}
